/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Overview_Open_RegistrationInputs */



/**
* | output |
* | --- |
* | "Open Registration" |
*
* @param {Overview_Open_RegistrationInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const overview_open_registration = /** @type {((inputs?: Overview_Open_RegistrationInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overview_Open_RegistrationInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ouvrir les inscriptions")
	if (locale === "es") return /** @type {LocalizedString} */ ("Abrir inscripción")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Abrir Inscrições")
	if (locale === "it") return /** @type {LocalizedString} */ ("Apri Iscrizione")
	return /** @type {LocalizedString} */ ("Open Registration")
});